import React from "react";
import CheckoutResult from "../CheckoutResult";
import isEmpty from "lodash/isEmpty";
import Pill from "components/Pill";
import { STATUS, UI_THEME } from "utils/constants/ui";
import HoverIconButton from "components/HoverIconButton";

const CheckoutPreview = ({ checkout, onClick, name, uuid, clearResult }) => {
  const isComplete = !isEmpty(checkout);

  return (
    <div className="w-100">
      <div className="flex flex-row justify-between ph3 bb hairline-1 pv1">
        <div className="dib">
          <HoverIconButton
            type="refresh"
            tooltip="Clear"
            onClick={clearResult}
            disabled={!clearResult}
          />
        </div>
      </div>
      <div
        onClick={onClick}
        className="flex flex-column w-100 pa3 bb hairline-1 relative pointer relative bg-white--hover bh--inset--hover"
      >
        <div className="flex flex-row justify-between items-center pb2">
          <Pill
            theme={UI_THEME.SLIM}
            status={isComplete ? STATUS.SUCCESS : STATUS.WARNING}
            copy={isComplete ? "Complete" : "Incomplete"}
          />
        </div>
        <div className="pt2">
          <CheckoutResult name={name} uuid={uuid} checkout={checkout} />
        </div>
      </div>
    </div>
  );
};

export default CheckoutPreview;
